export default {
    currentLang: localStorage.getItem("lang") ? localStorage.getItem("lang") : navigator.language.substring(0, 2),//浏览器默认语言
}



// WEBPACK FOOTER //
// ./src/store/state.js